
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/topBar/dropPanel/helpWidget/helpChatbotEntry.scss.css.virtualfile';
        module.exports = {"helpChatbotEntry":"_helpChatbotEntry_10403_1","helpWidgetSdkLoader":"_helpWidgetSdkLoader_10403_5"};